/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';
import metadata from '../block.json';
/**
 * Internal dependencies
 */
import Edit from './edit';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
// registerBlockType('wp-oer-plugin/wp-oer-resource-block', {
//     /**
//      * This is the display title for your block, which can be translated with `i18n` functions.
//      * The block inserter will show this name.
//      */
//     title: __('OER Resource Block', 'wp-oer-resource-block'),

//     /**
//      * This is a short description for your block, can be translated with `i18n` functions.
//      * It will be shown in the Block Tab in the Settings Sidebar.
//      */
//     description: __('This block displays a single resource on a page.','wp-oer-resource-block'),

//     /**
//      * Blocks are grouped into categories to help users browse and discover them.
//      * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
//      */
//     category: 'oer-block-category',

//     /**
//      * An icon property should be specified to make it easier to identify a block.
//      * These can be any of WordPress’ Dashicons, or a custom svg element.
//      */
//     icon: {
//         foreground: '#121212',
//         src: 'media-document'
//     },

//     keywords: [__('OER', 'oer-subject-resource-block'), __('Resource', 'oer-subject-resource-block')],

//     attributes : {
//         resources: {
//             type: 'object'
//         },
//         selectedResource: {
//             type: 'number'
//         },
//         alignment: {
//             type: 'string',
//         },
//         blockWidth: {
//             type: 'string'
//         },
//         showThumbnail: {
//             type:'boolean',
//             default: false
//         }, 
//         showTitle: {
//             type:'boolean',
//             default:false
//         },
//         showDescription: {
//             type:'boolean',
//             default: false
//         }, 
//         showSubjects: {
//             type: 'boolean',
//             default: false
//         },
//         showGrades: {
//             type: 'boolean',
//             default: false
//         },
//         withBorder: {
//             type: 'boolean',
//             default: false
//         },
//         blockId: {
//             type: 'string'
//         },
//         firstLoad: {
//             type: 'boolean',
//             default: true
//         },
//         isChanged: {
//             type: 'boolean',
//             default: false
//         }
//     },
// 	/**
// 	 * @see ./edit.js
// 	 */
// 	edit: Edit,
// });
registerBlockType( metadata, {
    edit: Edit,
});
